import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FilterService } from '../../../services/filter/filter.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    styleUrl: './filter.component.scss',
    standalone: false
})
export class FilterComponent<T> {

  activeFilter: any;

  @Input() filterData: T;
  @Output() applyFilter = new EventEmitter<T>();
  @Output() resetFilter = new EventEmitter<void>(); 

  @Output() changeActiveFiltersCount = new EventEmitter<void>();

  @Output() activeFiltersCountVisible = new EventEmitter<boolean>(false)

  @Output() activeFiltersCount = new EventEmitter<number>();

  constructor(private filterService: FilterService, private router: Router) { }
  
  ngOnInit(): void {
    const currentUrl = this.router.url; 
    this.activeFilter = this.filterService.getFilterState(currentUrl);
  }

  onCancel() {
    this.resetFilter.emit();
    this.closeFilter();
  }
  onApply() {
    this.applyFilter.emit(this.filterData);
    this.closeFilter();
    this.changeActiveFiltersCount.emit(); 
  }

  closeFilter() {
    const currentUrl = this.router.url;
    this.filterService.closeFilter(currentUrl);
  }

}
